import React from 'react';
import { Text } from '@applane/react-core-components';
import { Form } from '../../../app-components/form/Form';
import { viewUri } from '../../../Queries/avGenerationHistory';
import { getUserRole } from '../../../Lib/helpers';

export const ViewAppraisal = (props) => {
  const arr = [];
  const userRole = getUserRole();

  if (userRole !== 'dealer' || userRole !== 'superdealer') {
    arr.push({
      type: 'text',
      field: 'madeByName',
      label: 'Made By',
      editable: false,
    });
  }

  arr.push({
    type: 'text',
    field: 'repairorder',
    label: 'Stock#',
    editable: false,
  });

  arr.push({
    type: 'text',
    field: 'name',
    label: 'Customer Name',
    editable: false,
  });

  arr.push({
    label: 'Customer Email',
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{data.email ? data.email : '--'}</Text>
    ),
  });

  arr.push({
    type: 'text',
    field: 'mobilenumber',
    label: 'Phone #',
    editable: false,
  });

  arr.push({
    type: 'text',
    field: 'vin',
    label: 'VIN',
    editable: false,
  });
  arr.push({
    type: 'text',
    field: 'mileage',
    label: 'Mileage',
    editable: false,
  });
  arr.push({
    type: 'date',
    field: 'checkDate',
    label: 'Date Generated',
    editable: false,
  });

  arr.push({
    label: 'Original Price',
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{`$ ${data.rmbp}`}</Text>
    ),
  });
  arr.push({
    type: 'text',
    field: 'finalrange',
    label: 'Final Range',
    editable: false,
  });
  arr.push({
    label: 'Spread',
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{`${data.ruleSpread} %`}</Text>
    ),
  });
  arr.push({
    label: 'Rule Enhancement',
    render: ({ data }) => (
      <Text style={{ fontSize: 17 }}>{`${data.ruleEnhancement} %`}</Text>
    ),
  });
  return (
    <Form
      type="standard"
      uri={viewUri}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: arr,
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};
